import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { ThemeProvider } from 'styled-components';
import { compose, identity } from 'ramda';

import { Container, Text, Icon, Loader, LoaderWrapper } from './button.styles';
import { renderWhenNotNil, renderWhenTrue, renderWhenTrueOtherwise } from '../../utils/rendering';
import { BUTTON_PRIMARY_TYPE, BUTTON_TYPES } from './button.constants';
import { ICONS_TYPES } from '../icon';

export class ButtonComponent extends PureComponent {
  static propTypes = {
    isLoaderVisible: PropTypes.bool,
    children: PropTypes.any,
    className: PropTypes.any,
    dark: PropTypes.bool,
    disabled: PropTypes.bool,
    icon: PropTypes.oneOf(ICONS_TYPES),
    label: PropTypes.string,
    theme: PropTypes.oneOf(BUTTON_TYPES),
    type: PropTypes.string,
    wide: PropTypes.bool,
    onClick: PropTypes.func,
  };

  static defaultProps = {
    isLoaderVisible: false,
    label: '',
    onClick: identity,
    theme: BUTTON_PRIMARY_TYPE,
  };

  handleClick = () => {
    if (this.props.disabled || this.props.isLoaderVisible) {
      return;
    }

    this.props.onClick();
  };

  renderIcon = renderWhenNotNil(() => <Icon name={this.props.icon} />);

  renderContent = renderWhenTrueOtherwise(
    () => (
      <Fragment>
        <Text>{this.props.label}</Text>
        {this.renderIcon(this.props.icon)}
      </Fragment>
    ),
    () => this.props.children
  );

  renderLoader = renderWhenTrue(() => (
    <LoaderWrapper>
      <Loader />
    </LoaderWrapper>
  ));

  render() {
    const { dark, disabled, theme, children, type, className, wide, isLoaderVisible } = this.props;
    return (
      <ThemeProvider theme={{ dark, disabled, theme, wide }}>
        <Container type={type} onClick={this.handleClick} className={className}>
          {this.renderContent(!children)}
          {this.renderLoader(isLoaderVisible)}
        </Container>
      </ThemeProvider>
    );
  }
}

export const Button = compose(injectIntl)(ButtonComponent);
